import { render, staticRenderFns } from "./ActFiles.vue?vue&type=template&id=068fb4b5&scoped=true"
import script from "./ActFiles.vue?vue&type=script&lang=js"
export * from "./ActFiles.vue?vue&type=script&lang=js"
import style0 from "./ActFiles.vue?vue&type=style&index=0&id=068fb4b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068fb4b5",
  null
  
)

export default component.exports